// tokens.js
// Single source of truth for the app's visual design language.
// Change a value here and it propagates anywhere the theme is consumed.
// These values were reverse-engineered from the colors/fonts/radii/shadows
// that were previously hardcoded across ~45 component files.

export const colors = {
  // Brand
  primary: "#00D0BD", // teal accent (was rgb(0, 208, 189) / #00D0BD)
  primaryRgb: "0, 208, 189",

  // Backgrounds / surfaces (dark navy theme)
  background: "#0E1529", // app background + primary button bg
  surface: "#1A2033", // cards, modals, inputs
  surfaceAlt: "#2b303b", // dropdowns, disabled fields, gradients
  sidebar: "#475378",

  // Lines / borders
  border: "#1F2C41",
  scrollbarThumb: "#4A4F5E",

  // Text
  textPrimary: "#FFFFFF",
  textSecondary: "#F4F4F4",
  textMuted: "lightgray",
  textDisabledLabel: "darkgray",
};

export const fonts = {
  // Primary UI font stack
  primary:
    "Montserrat, Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  mono: "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace",
};

export const radii = {
  sm: 5,
  md: 10,
  lg: 15,
  xl: 20,
};

export const shadows = {
  // The signature teal "glow" button effect (rest + hover)
  glowRest: `0px 4px 15px rgba(${colors.primaryRgb}, 0)`,
  glowHover: `0px 6px 20px rgba(${colors.primaryRgb}, 0.9)`,
  // Generic elevation
  card: "0 4px 15px rgba(0, 0, 0, 0.3)",
  cardHover: "0 8px 20px rgba(0, 0, 0, 0.3)",
  modal: "0 4px 6px rgba(0, 0, 0, 0.1)",
};

export const transitions = {
  glow: "box-shadow 0.3s ease-in-out, color 0.3s ease-in-out",
};

// Responsive breakpoints (px). We keep MUI's standard 5 and add `laptop: 1100`
// to preserve the app's existing 1100px cutoff that was hardcoded in many
// window.innerWidth checks.
export const breakpoints = {
  xs: 0,
  sm: 600,
  md: 900,
  laptop: 1100,
  lg: 1200,
  xl: 1536,
};
